import React from "react";
import { useRouter } from "next/router";
import SalesTaxCalc from "../../../components/Tools/SalesTaxCalculator/SalesTaxCalc";
import salesTaxRates from "../../../constants/taxrate";
import SalesTaxData from "./SalesTaxData";
import Blog from "../../../components/CalculatorBlogs/Blog";
import { BlogData } from ".";
import Head from "next/head";

async function getTaxRates(stateName) {
  let posts = {};
  await new Promise((resolve, reject) => {
    posts = salesTaxRates[stateName];
    resolve(posts);
  });
  return posts;
}

export const getStaticProps = async ({ params }) => {
  const taxRate = await getTaxRates(
    params.salestaxcalculator.toString().replaceAll(" ", "")
  );
  // console.log(taxRate)
  return {
    props: { taxRate },
  };
};

export const getStaticPaths = async () => {
  const salesTaxes = Object.keys(salesTaxRates);
  let paths = [];
  salesTaxes.forEach((salesTax) => {
    paths.push({ params: { salestaxcalculator: salesTax } });
  });
  return {
    paths: paths,
    fallback: true,
  };
};

const SalesTaxCalculator = ({ taxRate }) => {
  return (
    <>
      <div className="container mx-auto w-full px-[10px] lg:px-[100px] py-[80px] flex flex-col items-center gap-[20px]">
        <Head>
          <meta charSet="utf-8" />
          <title>
            {`${taxRate?.state}`} Sales Tax Calculator | Calculators | BoloSign
          </title>
          <meta
            name="description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta name="geo.region" content="IN" />
          <meta name="geo.position" content="22.351115;78.667743" />
          <meta name="ICBM" content="22.351115, 78.667743" />
          <meta name="author" content="BoloSign" />
          <meta name="publisher" content="BoloSign " />
          <meta
            name="robots"
            content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
          />
          <link
            rel="canonical"
            href={`https://www.bolosign.com/${taxRate?.link}`}
          />

          <meta
            property="og:url"
            content={`https://www.bolosign.com/${taxRate?.link}`}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content={`${taxRate?.state} Sales Tax Calculator Calculator | Calculators | BoloSign`}
          />
          <meta
            property="og:description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            property="og:image"
            content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:domain" content="https://bolosign.com" />
          <meta
            property="twitter:url"
            content={`https://www.bolosign.com/${taxRate?.link}`}
          />
          <meta
            name="twitter:title"
            content={`${taxRate?.state} Sales Tax Calculator Calculator | Calculators | BoloSign`}
          />
          <meta
            name="twitter:description"
            content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
          />
          <meta
            name="twitter:image"
            content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
          />
        </Head>
        <div className="absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[600px]"></div>
        <div className="flex flex-col gap-[30px] w-full xl:w-[70%] text-center">
          <h1 className="font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white">
            Sales Tax Calculator
          </h1>
          <div className="text-white text-[16px] xl:text-[18px] font-light">
            {taxRate ? taxRate.desc : "Page Not Found"}
          </div>
        </div>
        {taxRate ? (
          <SalesTaxCalc
            salesTaxState={taxRate.state}
            state_tax={taxRate.salesTaxRate}
            avg_local_tax={taxRate.averageLocalTaxRate}
            max_local_tax={taxRate.maxLocalTaxRate}
            combined_tax={taxRate.combinedRate}
          />
        ) : (
          <h1 className="text-center text-[40px] font-extralight">
            Page Not Found
          </h1>
        )}
        <SalesTaxData />
        {/* <br /><br /><br /><br /> */}
      </div>
      <Blog heading="Sales Tax Calculator FAQs" BlogData={BlogData} />
    </>
  );
};

export default SalesTaxCalculator;
